<div class="row mb-2">
    <div class="col-12">
      <ul class="nav nav-pills justify-content-end">
        <li class="nav-item">
          <a class="nav-link disabled" href="javascript: void(0);" tabindex="-1" aria-disabled="true">View :</a>
        </li>
        <li class="nav-item" data-toggle="tooltip" data-placement="top" ngbTooltip="List">
          <a class="nav-link" [class.active]="viewMode === 'list'" href="javascript: void(0);" (click)="onViewModeChange('list')">
            <i class="mdi mdi-format-list-bulleted"></i>
          </a>
        </li>
        <li class="nav-item" data-toggle="tooltip" data-placement="top" ngbTooltip="Grid">
          <a class="nav-link" [class.active]="viewMode === 'grid'" href="javascript: void(0);" (click)="onViewModeChange('grid')">
            <i class="mdi mdi-view-grid-outline"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>